/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */

export const filterData = (data, filterType, filter, clearFilters) => {
  const filtered = { ...data };
  if (clearFilters) {
    filtered.facets.location = false;
    filtered.facets.category = false;
    filtered.facets.civilian = false;
  }
  filtered.facets[filterType] = (filter === 'all' ? false : filter);
  filtered.items = [];
  let filteredItems = [];

  // location only
  if (filtered.facets.location && !filtered.facets.civilian && !filtered.facets.category) {
    filteredItems = data.items.filter(
      (el) => el.data.Location === (filtered.facets.location ? filtered.facets.location : el.data.Location),
    );
  }
  // civilian only
  if (filtered.facets.civilian && !filtered.facets.category) {
    filteredItems = data.items.filter(
      (el) => el.data.Location === (filtered.facets.location ? filtered.facets.location : el.data.Location)
      && (el.data.Warcrime_Facet !== null ? el.data.Warcrime_Facet.includes(filtered.facets.civilian) : false),
    );
  }
  // category only
  if (!filtered.facets.civilian && filtered.facets.category) {
    filteredItems = data.items.filter(
      (el) => el.data.Location === (filtered.facets.location ? filtered.facets.location : el.data.Location)
      && el.data.Warcrime_Category.includes(filtered.facets.category),
    );
  }
  // category and civilian
  if (filtered.facets.civilian && filtered.facets.category) {
    filteredItems = data.items.filter(
      (el) => el.data.Location === (filtered.facets.location ? filtered.facets.location : el.data.Location)
      && el.data.Warcrime_Category.includes(filtered.facets.category)
      && (el.data.Warcrime_Facet !== null ? el.data.Warcrime_Facet.includes(filtered.facets.civilian) : false),
    );
  }
  // reset visibility
  data.items.forEach((item) => {
    const newItem = { ...item };
    newItem.visible = false;
    filtered.items.push(newItem);
  });
  if (filteredItems.length > 0) {
    filteredItems.forEach((item) => {
      const visibleItem = filtered.items.find((obj) => obj.id === item.id);
      visibleItem.visible = true;
    });
  } else if (!filtered.facets.location && !filtered.facets.category && !filtered.facets.civilian) {
    filtered.items.forEach((item) => {
      item.visible = true;
    });
  }
  let totalCount = 0;
  filtered.items.forEach((item) => {
    if (item.visible) {
      totalCount += 1;
    }
  });
  filtered.facets.totalCount = totalCount;
  // make filtered items visible
  return filtered;
};
